/* Asnowera theme behaviour */
(function () {
  'use strict';
  var ASN = window.ASN = window.ASN || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function inr(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  /* every meaningful word typed must be present (title, type, tags, colour) */
  var STOP = ' set sets for women woman womens ladies lady girls the a an and with of in on new buy online outfit outfits ';
  ASN.strictMatch = function (q, hay) {
    var h = String(hay || '').toLowerCase().replace(/[-\s]/g, '');
    return String(q || '').toLowerCase().replace(/-/g, '').split(/[\s,\/&]+/).filter(function (w) { return w.length > 1 && STOP.indexOf(' ' + w + ' ') < 0; })
      .every(function (w) { return h.indexOf(w) > -1 || (w.length > 3 && w.slice(-1) === 's' && h.indexOf(w.slice(0, -1)) > -1); });
  };
  function img(url, w) { if (!url) return ''; return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2'); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false; t.classList.add('as-toast');
    clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 2600);
  }
  ASN.toast = toast;

  /* ---------- overlays (drawers / sheets) ---------- */
  var openEl = null, lastFocus = null;
  function scrimFor(el) {
    var root = el.closest('.as-s') || document;
    return $('.as-scrim', root) || $('.as-scrim');
  }
  function openOverlay(id) {
    var el = document.getElementById(id); if (!el) return;
    if (openEl && openEl !== el) closeOverlay(true);
    lastFocus = document.activeElement;
    var sc = scrimFor(el); if (sc) sc.hidden = false;
    el.hidden = false; openEl = el;
    document.body.classList.add('as-lock');
    var f = el.querySelector('button, a, input'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 30);
    if (id === 'as-cart') renderCart();
  }
  function closeOverlay(silent) {
    if (!openEl) return;
    var sc = scrimFor(openEl); if (sc) sc.hidden = true;
    $$('.as-scrim').forEach(function (s) { s.hidden = true; });
    openEl.hidden = true; openEl = null;
    document.body.classList.remove('as-lock');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  ASN.open = openOverlay; ASN.close = closeOverlay;

  document.addEventListener('click', function (e) {
    var t = e.target;
    var op = t.closest('[data-open]');
    if (op) { e.preventDefault(); openOverlay(op.getAttribute('data-open')); return; }
    if (t.closest('[data-close]')) { e.preventDefault(); closeOverlay(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var sg = document.getElementById('as-size-guide'); if (sg && sg.open) return; if (openEl) closeOverlay(); closeMega(); }
  });

  /* ---------- announcement ---------- */
  (function () {
    var bar = $('[data-ann]'); if (!bar) return;
    var list = []; try { list = JSON.parse(bar.getAttribute('data-ann')).filter(Boolean); } catch (e) {}
    var msg = $('.as-ann-msg', bar); if (!msg || list.length < 2) { $$('[data-ann-nav]', bar).forEach(function (b) { b.style.visibility = 'hidden'; }); return; }
    var i = 0;
    function show(n) { i = (n + list.length) % list.length; msg.style.opacity = 0; setTimeout(function () { msg.textContent = list[i]; msg.style.opacity = 1; }, 250); }
    bar.addEventListener('click', function (e) { var b = e.target.closest('[data-ann-nav]'); if (b) { show(i + Number(b.getAttribute('data-ann-nav'))); restart(); } });
    var timer; function restart() { clearInterval(timer); if (!reduce) timer = setInterval(function () { if (!document.hidden) show(i + 1); }, 5000); }
    restart();
  })();

  /* ---------- mega menu ---------- */
  var mega = $('#as-mega'), megaBtn = $('[data-mega]');
  function closeMega() { if (mega && !mega.hidden) { mega.hidden = true; if (megaBtn) megaBtn.setAttribute('aria-expanded', 'false'); } }
  if (mega && megaBtn) {
    megaBtn.addEventListener('click', function (e) { e.stopPropagation(); var o = mega.hidden; mega.hidden = !o; megaBtn.setAttribute('aria-expanded', String(o)); });
    document.addEventListener('click', function (e) { if (!e.target.closest('#as-mega') && !e.target.closest('[data-mega]')) closeMega(); });
  }

  /* ---------- search ---------- */
  var ms = $('[data-msearch]'), msBtn = $('[data-toggle-search]');
  if (ms && msBtn) msBtn.addEventListener('click', function () { ms.hidden = !ms.hidden; msBtn.setAttribute('aria-expanded', String(!ms.hidden)); if (!ms.hidden) { var i = $('input[name=q]', ms); if (i) i.focus(); } });
  (function () {
    var form = $('[data-search-form]'); if (!form) return;
    var input = $('[data-search-input]', form), box = $('[data-suggest]', form), t;
    input.addEventListener('input', function () {
      clearTimeout(t); var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,tag,variants.title')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            ps = ps.filter(function (p) { return ASN.strictMatch(q, [p.title, p.type, (p.tags || []).join(' ')].join(' ')); }).slice(0, 6);
            if (!ps.length) { box.innerHTML = '<a class="as-all" href="/search?q=' + encodeURIComponent(q) + '">Search for “' + esc(q) + '”</a>'; box.hidden = false; return; }
            box.innerHTML = ps.map(function (p) { return '<a href="' + p.url + '">' + (p.image ? '<img src="' + img(p.image, 120) + '" alt="">' : '') + '<span>' + esc(p.title) + '<br><b>' + inr(parseFloat(p.price) * 100) + '</b></span></a>'; }).join('') + '<a class="as-all" href="/search?q=' + encodeURIComponent(q) + '&options[prefix]=last">See all results →</a>';
            box.hidden = false;
          }).catch(function () { box.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-search-form]')) box.hidden = true; });
  })();

  /* ---------- wishlist (shared with the store's wishlist page) ---------- */
  var WKEY = 'shopify-wishlist';
  function wishList() { var v = store(WKEY); return v ? v.split(',').filter(Boolean) : []; }
  function wishSync() {
    var l = wishList();
    $$('[data-wish]').forEach(function (b) { var on = l.indexOf(b.getAttribute('data-wish')) > -1; b.classList.toggle('as-on', on); b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-label', (on ? 'Remove from' : 'Add to') + ' wishlist'); });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = l.length; c.hidden = !l.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), l = wishList(), i = l.indexOf(h);
    if (i > -1) { l.splice(i, 1); toast('Removed from your wishlist'); } else { l.push(h); toast('Saved to your wishlist'); }
    store(WKEY, l.join(','));
    wishSync();
  });
  wishSync();

  /* ---------- cart ---------- */
  var upsell = []; try { upsell = JSON.parse(($('#as-upsell-data') || {}).textContent || '[]'); } catch (e) {}
  var cartCache = null;
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartCache = c; updateCount(c); return c; }); }
  function updateCount(c) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
    var lab = $('[data-cart-label]'); if (lab) lab.textContent = '(' + c.item_count + ' ' + (c.item_count === 1 ? 'item' : 'items') + ')';
  }
  function cartAdd(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function (j) { document.dispatchEvent(new CustomEvent('asn:cart-added', { detail: j })); return j; });
  }
  ASN.cartAdd = cartAdd;
  function cartChange(line, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function renderCart(c) {
    var drawer = $('#as-cart'); if (!drawer) return;
    if (!c) { getCart().then(renderCart); return; }
    cartCache = c; updateCount(c);
    var n = c.item_count;
    $$('[data-cart-segs] i', drawer).forEach(function (s, i) { s.classList.toggle('as-on', n >= i + 1); });
    var msg = n >= 3 ? '<b style="color:var(--save)">15% off unlocked!</b> Your best price applies at checkout.' : n === 2 ? '<b style="color:var(--save)">10% off unlocked!</b> Add <b>1 more</b> item to get <b>15% off</b>' : n === 1 ? 'Add <b>1 more</b> item to get <b>10% off</b>' : 'Buy 2, get 10% off · Buy 3, get 15% off';
    $('[data-cart-msg]', drawer).innerHTML = msg;
    var itemsEl = $('[data-cart-items]', drawer), foot = $('[data-cart-foot]', drawer);
    if (!c.items.length) {
      itemsEl.innerHTML = '<div class="as-empty" style="margin-top:20px"><b style="color:var(--ink);display:block;margin-bottom:8px">Your cart is empty</b><a class="as-btn as-btn-primary" href="/collections/trending-styles">Shop Trending Styles</a></div>';
      foot.hidden = true; return;
    }
    var html = c.items.map(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
      var orig = it.original_line_price > it.final_line_price ? ' <s style="font-size:12px;color:var(--muted)">' + inr(it.original_line_price) + '</s>' : '';
      return '<div class="as-line"><a href="' + it.url + '">' + (it.image ? '<img src="' + img(it.image, 200) + '" alt="" width="80" height="106" loading="lazy">' : '') + '</a><div style="display:flex;flex-direction:column;gap:4px;min-width:0">' +
        '<div class="as-t"><a href="' + it.url + '">' + esc(it.product_title) + '</a><button type="button" class="as-iconbtn" data-line-rm="' + (i + 1) + '" aria-label="Remove ' + esc(it.product_title) + '"><svg class="as-icon" viewBox="0 0 24 24" style="width:17px;height:17px"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button></div>' +
        (opts ? '<span class="as-m">' + opts + '</span>' : '') +
        '<div class="as-b"><div class="as-miniqty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div><div><b>' + inr(it.final_line_price) + '</b>' + orig + '</div></div></div></div>';
    }).join('');
    var inCart = c.items.map(function (i) { return i.handle; });
    var ups = upsell.filter(function (p) { return inCart.indexOf(p.handle) < 0; }).slice(0, 2);
    if (ups.length && n < 3) {
      html += '<div style="padding-block:16px 8px"><b style="font-size:13.5px">' + (n === 2 ? 'Add one more for 15% off' : 'You may also like') + '</b>' + ups.map(function (p) {
        return '<div class="as-upsell"><img src="' + p.img + '" alt="" width="44" height="58" loading="lazy"><div><a href="' + p.url + '" style="color:var(--ink);text-decoration:none">' + esc(p.title) + '</a><br><b>' + inr(p.price) + '</b></div><button type="button" class="as-btn as-btn-outline" data-quick="' + esc(p.handle) + '" style="min-height:44px;padding:0 14px">Add</button></div>';
      }).join('') + '</div>';
    }
    itemsEl.innerHTML = html;
    foot.hidden = false;
    var sub = c.items_subtotal_price, real = c.total_discount || 0;
    var rate = n >= 3 ? 0.15 : n === 2 ? 0.10 : 0;
    $('[data-cart-sub]', drawer).textContent = inr(c.original_total_price || sub);
    var dRow = $('[data-cart-disc]', drawer), total;
    if (real > 0) {
      dRow.hidden = false;
      var labels = (c.cart_level_discount_applications || []).map(function (d) { return d.title; }).concat([]);
      $('[data-cart-disc-label]', drawer).textContent = labels.length ? labels.join(', ') : 'Discount';
      $('[data-cart-disc-val]', drawer).textContent = '−' + inr(real);
      total = c.total_price; $('[data-cart-tot-label]', drawer).textContent = 'Total';
    } else if (rate) {
      dRow.hidden = false;
      $('[data-cart-disc-label]', drawer).textContent = 'Buy ' + (n >= 3 ? '3' : '2') + ' offer (' + rate * 100 + '%)';
      var est = Math.round(sub * rate / 100) * 100;
      $('[data-cart-disc-val]', drawer).textContent = '−' + inr(est);
      total = sub - est; $('[data-cart-tot-label]', drawer).textContent = 'Estimated total';
    } else {
      dRow.hidden = true; total = c.total_price; $('[data-cart-tot-label]', drawer).textContent = 'Total';
    }
    $('[data-cart-tot]', drawer).textContent = inr(total);
    $('[data-cart-prepaid]', drawer).innerHTML = 'Pay online &amp; pay just <b>' + inr(Math.round(total * 0.95 / 100) * 100) + '</b> (extra 5% off)';
  }
  ASN.renderCart = renderCart;
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line]'), rm = e.target.closest('[data-line-rm]');
    if (!q && !rm) return;
    var line = Number((q || rm).getAttribute(q ? 'data-line' : 'data-line-rm')), qty = rm ? 0 : Number(q.getAttribute('data-q'));
    var box = $('[data-cart-items]'); if (box) box.classList.add('as-busy');
    cartChange(line, Math.max(0, qty)).then(function (c) { if (box) box.classList.remove('as-busy'); renderCart(c); }).catch(function () { if (box) box.classList.remove('as-busy'); toast('Could not update your cart. Please try again.'); });
  });
  document.addEventListener('asn:cart-added', function () { getCart().then(function (c) { openOverlay('as-cart'); renderCart(c); }); });
  // Fallback checkout: hand over to the store's checkout app when present
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.as-checkout-fallback'); if (!b) return;
    if (window.shiprocketCheckoutEvents && typeof window.shiprocketCheckoutEvents.buyCart === 'function') { e.preventDefault(); try { window.shiprocketCheckoutEvents.buyCart(e); } catch (err) { location.href = '/checkout'; } }
  });

  /* ---------- quick add ---------- */
  var quick = $('#as-quick'), qState = null;
  function qRender() {
    if (!quick || !qState) return;
    var p = qState.p, si = qState.si, sel = qState.sel;
    var btn = $('[data-q-add]', quick);
    var v = qState.variant();
    btn.disabled = !v || !v.available;
    btn.textContent = !sel && p.variants.length > 1 ? 'Select a size' : (v && !v.available ? 'Sold out' : 'Add to cart' + (sel ? ' · ' + sel : ''));
    $$('[data-q-sizes] .as-sz', quick).forEach(function (b) { var on = b.getAttribute('data-v') === sel; b.classList.toggle('as-on', on); b.setAttribute('aria-pressed', String(on)); });
  }
  function openQuick(handle) {
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      if (p.variants.length === 1) {
        if (!p.variants[0].available) { toast('This style is sold out'); return; }
        return cartAdd([{ id: p.variants[0].id, quantity: 1 }]).catch(function (err) { toast(err.message); });
      }
      var si = 0; p.options.forEach(function (o, i) { if (/size/i.test(o.name || o)) si = i; });
      var opt = p.options[si], vals = opt.values || [];
      qState = { p: p, si: si, sel: null, variant: function () {
        var s = this.sel; if (!s) return null;
        var m = p.variants.filter(function (v) { return v.options[si] === s; });
        return m.filter(function (v) { return v.available; })[0] || m[0] || null;
      } };
      $('[data-q-img]', quick).src = img(p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '', 200);
      $('[data-q-title]', quick).textContent = p.title;
      $('[data-q-price]', quick).innerHTML = '<b>' + inr(p.price) + '</b>' + (p.compare_at_price > p.price ? '<s>' + inr(p.compare_at_price) + '</s>' : '');
      $('[data-q-optname]', quick).textContent = 'Select ' + String(opt.name || opt).toLowerCase();
      $('[data-q-sizes]', quick).innerHTML = vals.map(function (v) {
        var avail = p.variants.some(function (x) { return x.options[si] === v && x.available; });
        return '<button type="button" class="as-sz' + (avail ? '' : ' as-na') + '" data-v="' + esc(v) + '" ' + (avail ? '' : 'disabled') + ' aria-pressed="false">' + esc(v) + '</button>';
      }).join('');
      if ((p.tags || []).some(function (t) { return /co-?ord/i.test(t); })) {
        var okq = function (val) { return p.variants.some(function (x) { return x.options[si] === val && x.available; }); };
        qState.sel = vals.filter(function (v) { return String(v).trim().toLowerCase() === 's' && okq(v); })[0] || vals.filter(okq)[0] || null;
      }
      qRender(); openOverlay('as-quick');
    }).catch(function () { location.href = '/products/' + handle; });
  }
  ASN.openQuick = openQuick;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick]'); if (!b) return;
    e.preventDefault(); openQuick(b.getAttribute('data-quick'));
  });
  if (quick) quick.addEventListener('click', function (e) {
    var s = e.target.closest('[data-q-sizes] .as-sz'); if (s && !s.disabled) { qState.sel = s.getAttribute('data-v'); qRender(); return; }
    var a = e.target.closest('[data-q-add]');
    if (a && qState) { var v = qState.variant(); if (!v) return; a.disabled = true; cartAdd([{ id: v.id, quantity: 1 }]).then(function () { closeOverlay(true); }).catch(function (err) { toast(err.message); a.disabled = false; }); }
  });

  /* ---------- home: slider, rails, tabs ---------- */
  $$('[data-slider]').forEach(function (sl) {
    var track = $('.as-slides', sl), n = $$('.as-slide', sl).length, cur = 0, timer, tx = null;
    function go(i) { cur = (i + n) % n; track.style.transform = 'translateX(-' + cur * 100 + '%)'; $$('.as-dots button', sl).forEach(function (b, k) { b.classList.toggle('as-on', k === cur); }); }
    function auto() { clearInterval(timer); if (!reduce) timer = setInterval(function () { if (!document.hidden && !openEl) go(cur + 1); }, 6000); }
    sl.addEventListener('click', function (e) { var d = e.target.closest('[data-slide]'), nv = e.target.closest('[data-slidenav]'); if (d) { go(Number(d.getAttribute('data-slide'))); auto(); } if (nv) { go(cur + Number(nv.getAttribute('data-slidenav'))); auto(); } });
    sl.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    sl.addEventListener('touchend', function (e) { if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; tx = null; if (Math.abs(dx) > 40) { go(cur + (dx < 0 ? 1 : -1)); auto(); } });
    auto();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rail]'); if (!b) return;
    var sec = b.closest('.as-sec'), r = sec && $('[data-rail-track], .as-rail', sec); if (r) r.scrollBy({ left: Number(b.getAttribute('data-rail')) * r.clientWidth * 0.8, behavior: 'smooth' });
  });
  $$('[data-tabs]').forEach(function (t) {
    t.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]'); if (!b) return;
      var k = b.getAttribute('data-tab');
      $$('[data-tab]', t).forEach(function (x) { var on = x === b; x.classList.toggle('as-on', on); x.setAttribute('aria-selected', String(on)); });
      $$('[data-tab-panel]', t).forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== k; });
      var l = $('[data-tab-link]', t); if (l) l.href = l.getAttribute('data-' + k);
      wishSync();
    });
  });

  /* ---------- collection: sort, load more ---------- */
  function setSort(v) { var u = new URL(location.href); u.searchParams.set('sort_by', v); u.searchParams.delete('page'); location.href = u.toString(); }
  $$('[data-sort]').forEach(function (s) { s.addEventListener('change', function () { setSort(s.value); }); });
  document.addEventListener('click', function (e) { var a = e.target.closest('[data-sortv]'); if (a) { e.preventDefault(); setSort(a.getAttribute('data-sortv')); } });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-load-more]'); if (!a) return;
    e.preventDefault(); a.classList.add('as-busy'); a.textContent = 'Loading…';
    fetch(a.href).then(function (r) { return r.text(); }).then(function (h) {
      var d = new DOMParser().parseFromString(h, 'text/html');
      var grid = $('[data-grid]'), add = $$('[data-grid] > .as-card', d);
      add.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
      var total = Number(a.getAttribute('data-total')), seen = $$('[data-grid] > .as-card').length;
      var lab = $('[data-more-label]'), bar = $('[data-more-bar]');
      if (lab) lab.textContent = "You've seen " + seen + ' of ' + total + ' styles';
      if (bar) bar.style.width = Math.min(100, Math.round(seen / total * 100)) + '%';
      var next = $('[data-load-more]', d);
      if (next) { a.href = next.getAttribute('href'); a.textContent = 'Load more styles'; a.classList.remove('as-busy'); } else a.remove();
      history.replaceState(null, '', a.href ? location.href : location.href);
      wishSync();
    }).catch(function () { location.href = a.href; });
  });

  /* ---------- product page ---------- */
  (function () {
    var root = $('[data-pdp]'); if (!root) return;
    document.body.classList.add('as-has-sticky');
    var data = {}; try { data = JSON.parse($('[data-product-json]').textContent); } catch (e) { return; }
    var form = $('#as-product-form'), idInput = $('[data-variant-input]', form);
    var single = root.getAttribute('data-single') === 'true';
    var si = data.sizeIndex;
    var opts = $$('.as-opt', form);
    var sel = opts.map(function (o, i) { if (i === si) return null; var on = $('.as-sz.as-on', o); return on ? on.getAttribute('data-val') : null; });
    function current() {
      if (single) return data.variants[0];
      if (sel.some(function (v) { return v === null; })) return null;
      return data.variants.filter(function (v) { return v.o.every(function (x, i) { return x === sel[i]; }); })[0] || null;
    }
    function availFor(i, val) {
      return data.variants.some(function (v) { return v.a && v.o[i] === val && v.o.every(function (x, k) { return k === i || sel[k] === null || sel[k] === x; }); });
    }
    function ui() {
      var v = current();
      opts.forEach(function (o, i) {
        $$('.as-sz', o).forEach(function (b) { var val = b.getAttribute('data-val'), on = sel[i] === val; b.classList.toggle('as-on', on); b.setAttribute('aria-pressed', String(on)); b.classList.toggle('as-na', !availFor(i, val)); });
        var lab = $('[data-opt-label]', o); if (lab) { lab.textContent = sel[i] || ('Select a ' + (i === si ? 'size' : 'option')); lab.style.color = sel[i] ? 'var(--ink)' : 'var(--muted)'; }
      });
      var atc = $('[data-atc]', form), bn = $('[data-buynow]', form), st = $('[data-sticky-btn]');
      if (v) {
        idInput.value = v.id;
        $('[data-price]', root).textContent = inr(v.p);
        var c = $('[data-cmp]', root), of = $('[data-off]', root), sv = $('[data-save]', root);
        if (v.c > v.p) { c.hidden = false; c.textContent = inr(v.c); of.hidden = false; of.textContent = Math.round((v.c - v.p) / v.c * 100) + '% OFF'; sv.hidden = false; sv.textContent = 'You save ' + inr(v.c - v.p) + ' · '; } else { c.hidden = true; of.hidden = true; sv.hidden = true; }
        $('[data-prepaid]', root).textContent = inr(Math.round(v.p * 0.95 / 100) * 100);
        var sp = $('[data-sa-price]'); if (sp) sp.textContent = inr(v.p);
        if (!single) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
        var szTxt = si > -1 && sel[si] ? ' · Size ' + sel[si] : '';
        atc.disabled = !v.a; atc.textContent = v.a ? 'Add to cart' + szTxt : 'Sold out';
        if (bn) bn.disabled = !v.a;
        var sbv = $('[data-sticky-buy]'); if (sbv) sbv.disabled = !v.a;
        if (st) { st.disabled = !v.a; st.textContent = v.a ? 'Add to cart' : 'Sold out'; var ss = $('[data-sa-sub]'); if (ss && si > -1 && sel[si]) ss.textContent = 'Size ' + sel[si]; }
        if (v.m) { var mi = $('.as-gal-m [data-media-id="' + v.m + '"]', root); if (mi) { var tr = $('[data-gal-track]', root); tr.scrollTo({ left: mi.offsetLeft, behavior: 'smooth' }); } }
      } else {
        atc.disabled = false; atc.textContent = 'Add to cart';
        if (st) { st.disabled = false; st.textContent = 'Add to cart'; }
        var sbb = $('[data-sticky-buy]'); if (sbb) sbb.disabled = false;
      }
    }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('.as-opt .as-sz'); if (!b) return;
      var o = b.closest('.as-opt'), i = opts.indexOf(o);
      sel[i] = b.getAttribute('data-val');
      var err = $('[data-size-err]', form); if (err) err.hidden = true; var hp = $('[data-size-help]', form); if (hp) hp.hidden = false;
      ui();
    });
    var qin = $('[data-qty-input]', form);
    form.addEventListener('click', function (e) { var b = e.target.closest('[data-qty]'); if (!b) return; qin.value = Math.max(1, Math.min(10, (Number(qin.value) || 1) + Number(b.getAttribute('data-qty')))); });
    function needSize() {
      var blk = $('#as-size-block', form) || opts[sel.indexOf(null)];
      var err = $('[data-size-err]', form); if (err) err.hidden = false; var hp = $('[data-size-help]', form); if (hp) hp.hidden = true;
      if (blk) { blk.scrollIntoView({ behavior: 'smooth', block: 'center' }); blk.classList.remove('as-shake'); void blk.offsetWidth; blk.classList.add('as-shake'); }
    }
    function addCurrent(then) {
      var v = current(); if (!v) { needSize(); return Promise.reject(null); }
      if (!v.a) return Promise.reject(null);
      return cartAdd([{ id: v.id, quantity: Math.max(1, Number(qin.value) || 1) }]);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); var atc = $('[data-atc]', form); atc.classList.add('as-busy');
      addCurrent().then(function () { atc.classList.remove('as-busy'); }).catch(function (err) { atc.classList.remove('as-busy'); if (err) toast(err.message); });
    });
    var bn = $('[data-buynow]', form);
    form.addEventListener('click', function (e) {
      var srb = e.target.closest && e.target.closest('.shiprocket-headless .sr-headless-checkout');
      if (!srb) return;
      var v = current();
      if (!v || !v.a) { e.preventDefault(); e.stopPropagation(); if (!v) needSize(); return; }
      if (idInput) idInput.value = v.id;
    }, true);
    (function srSync() {
      $$('.as-buyrow').forEach(function (row) {
        var h = $('.shiprocket-headless', row);
        row.classList.toggle('as-sr-on', !!h && getComputedStyle(h).display !== 'none');
      });
      var sbI = $('[data-sticky-buy]');
      if (sbI && $('.as-buyrow.as-sr-on') && !$('.as-upi', sbI)) sbI.insertAdjacentHTML('beforeend', '<img class="as-upi" src="https://fastrr-boost-ui.pickrr.com/assets/images/boost_button/upi_options.svg" alt="UPI, Google Pay, PhonePe" width="44" height="18">');
    })();
    if (bn) bn.addEventListener('click', function () {
      var v = current(); if (!v) { needSize(); return; }
      bn.classList.add('as-busy');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: Math.max(1, Number(qin.value) || 1) }] }) })
        .then(function (r) { if (!r.ok) throw new Error(); location.href = '/checkout'; })
        .catch(function () { bn.classList.remove('as-busy'); toast('Could not start checkout. Please try again.'); });
    });
    // Shiprocket's buy button reads the selected variant from the form; make sure a size is chosen first
    form.addEventListener('click', function (e) {
      var sr = e.target.closest('.sr-headless-checkout'); if (!sr) return;
      if (!current()) { e.preventDefault(); e.stopImmediatePropagation(); needSize(); }
    }, true);
    var st = $('[data-sticky-btn]');
    if (st) st.addEventListener('click', function () { if (!current()) { needSize(); return; } form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    var sbuy = $('[data-sticky-buy]');
    if (sbuy) sbuy.addEventListener('click', function () { if (!current()) { needSize(); return; } var srb2 = $('.as-buyrow.as-sr-on .sr-headless-checkout'); if (srb2) srb2.click(); else if (bn) bn.click(); });
    // co-ord sets: start with a default size so Add to cart / Buy now never block (shopper can still change it)
    (function () {
      var ds = root.getAttribute('data-default-size'); if (!ds || single || si == null || si < 0 || !opts[si] || sel[si]) return;
      var vals = $$('.as-sz', opts[si]).map(function (b) { return b.getAttribute('data-val'); });
      var okv = function (val) { return data.variants.some(function (v) { return v.a && v.o[si] === val; }); };
      var pick = vals.filter(function (v) { return String(v).trim().toLowerCase() === ds.toLowerCase() && okv(v); })[0] || vals.filter(okv)[0];
      if (!pick) return;
      sel[si] = pick; ui();
    })();
    // gallery (mobile)
    var tr = $('[data-gal-track]', root), cnt = $('[data-gal-count]', root), thumbs = $$('[data-thumb]', root);
    if (tr) {
      var total = $$('img', tr).length;
      tr.addEventListener('scroll', function () { var i = Math.round(tr.scrollLeft / tr.clientWidth); if (cnt) cnt.textContent = (i + 1) + ' / ' + total; thumbs.forEach(function (t, k) { t.classList.toggle('as-on', k === i); }); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { tr.scrollTo({ left: tr.clientWidth * Number(t.getAttribute('data-thumb')), behavior: 'smooth' }); }); });
      if (total > 1) {
        [-1, 1].forEach(function (d) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'as-gal-nav ' + (d < 0 ? 'as-prev' : 'as-next');
          b.setAttribute('aria-label', d < 0 ? 'Previous photo' : 'Next photo');
          b.innerHTML = '<svg class="as-icon" viewBox="0 0 24 24"><path d="' + (d < 0 ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6') + '"/></svg>';
          b.addEventListener('click', function () { var i = (Math.round(tr.scrollLeft / tr.clientWidth) + d + total) % total; tr.scrollTo({ left: tr.clientWidth * i, behavior: 'smooth' }); });
          tr.parentNode.appendChild(b);
        });
        var tbox = thumbs.length ? thumbs[0].parentNode : null;
        tr.addEventListener('scroll', function () { var i = Math.round(tr.scrollLeft / tr.clientWidth), t = thumbs[i]; if (tbox && t) { if (tbox.scrollHeight > tbox.clientHeight + 4) tbox.scrollTop = t.offsetTop - tbox.clientHeight / 2 + t.offsetHeight / 2; else if (tbox.scrollWidth > tbox.clientWidth + 4) tbox.scrollLeft = t.offsetLeft - tbox.clientWidth / 2 + t.offsetWidth / 2; } }, { passive: true });
      }
    }
    // delivery estimate
    function day(n) { var x = new Date(); x.setDate(x.getDate() + n); return x.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
    var ea = $('[data-eta-a]', root), eb = $('[data-eta-b]', root); if (ea) ea.textContent = day(4); if (eb) eb.textContent = day(5);
    // pincode
    var pf = $('[data-pin]', root);
    if (pf) pf.addEventListener('submit', function (e) {
      e.preventDefault(); var v = ($('[data-pin-input]', pf).value || '').replace(/\D/g, ''), res = $('[data-pin-res]', root);
      if (!/^[1-9]\d{5}$/.test(v)) { res.innerHTML = '<span class="as-err">Enter a valid 6-digit pincode</span>'; return; }
      res.innerHTML = '<div class="as-ok" style="display:flex;gap:16px;flex-wrap:wrap"><span>✓ Free delivery to ' + v + ' by ' + day(5) + '</span><span>✓ COD available</span></div>';
    });
    $$('[data-jump]').forEach(function (a) { a.addEventListener('click', function (e) { var t = document.getElementById(a.getAttribute('data-jump')); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); } }); });
    // bundle builder
    var bb = $('[data-bundle]', root);
    if (bb) {
      var pool = []; try { pool = JSON.parse($('[data-bb-pool]', bb).textContent); } catch (e) {}
      var picks = [0, 1];
      var self = { title: $('h1', root).textContent, img: (($('.as-gallery img', root) || {}).src || ''), url: location.pathname };
      function selfPrice() { var v = current() || data.variants[0]; return v.p; }
      function rbb() {
        var items = [null].concat(picks.map(function (i) { return pool[i]; }));
        $('[data-bb-items]', bb).innerHTML = items.map(function (x, i) {
          var t = x || self, pr = x ? x.price : selfPrice();
          return (i ? '<span class="as-plus" aria-hidden="true">+</span>' : '') + '<div class="as-bb-item' + (i ? '' : ' as-this') + '"><img src="' + (x ? x.img : self.img) + '" alt="" width="64" height="86" loading="lazy"><div><small>' + (i ? 'Add' : 'This item') + '</small><a href="' + (x ? x.url : '#') + '">' + esc(t.title) + '</a><b>' + inr(pr) + '</b></div>' + (i ? '<button type="button" class="as-bb-swap" data-bswap="' + (i - 1) + '" aria-label="Swap for another style"><svg class="as-icon" viewBox="0 0 24 24" style="width:16px;height:16px"><path d="M4 12a8 8 0 0 1 14-5.3L20 9"/><path d="M20 4v5h-5"/><path d="M20 12a8 8 0 0 1-14 5.3L4 15"/><path d="M4 20v-5h5"/></svg></button>' : '') + '</div>';
        }).join('');
        var sub = selfPrice() + pool[picks[0]].price + pool[picks[1]].price;
        $('[data-bb-sub]', bb).textContent = inr(sub);
        $('[data-bb-tot]', bb).textContent = inr(Math.round(sub * 0.85 / 100) * 100);
        var s = si > -1 ? sel[si] : null;
        $('[data-bb-add]', bb).textContent = s ? 'Add all 3 · Size ' + s : 'Add all 3 to cart';
      }
      bb.addEventListener('click', function (e) {
        var sw = e.target.closest('[data-bswap]');
        if (sw) { var k = Number(sw.getAttribute('data-bswap')), other = picks[1 - k], n = picks[k]; do { n = (n + 1) % pool.length; } while (n === other); picks[k] = n; rbb(); return; }
        var add = e.target.closest('[data-bb-add]'); if (!add) return;
        var v = current(); if (!v) { needSize(); return; }
        var s = si > -1 ? sel[si] : null, items = [{ id: v.id, quantity: 1 }], note = false;
        picks.forEach(function (i) {
          var p = pool[i], m = null;
          if (s) m = p.variants.filter(function (x) { return x.a && x.o.indexOf(s) > -1; })[0];
          if (!m) { m = p.variants.filter(function (x) { return x.a; })[0]; if (s) note = true; }
          if (m) items.push({ id: m.id, quantity: 1 });
        });
        add.classList.add('as-busy');
        cartAdd(items).then(function () { add.classList.remove('as-busy'); if (note) toast('One style was added in its first available size — you can change it in the cart.'); }).catch(function (err) { add.classList.remove('as-busy'); toast(err.message); });
      });
      if (pool.length >= 2) rbb();
      form.addEventListener('click', function (e) { if (e.target.closest('.as-opt .as-sz')) rbb(); });
    }
    // recently viewed
    var RK = 'asn-recent', h = data.handle, rec = []; try { rec = JSON.parse(store(RK) || '[]'); } catch (e) {}
    var show = rec.filter(function (x) { return x !== h; }).slice(0, 8);
    store(RK, JSON.stringify([h].concat(show).slice(0, 12)));
    if (show.length) {
      Promise.all(show.map(function (x) { return fetch('/products/' + x + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (ps) {
        ps = ps.filter(Boolean); if (!ps.length) return;
        var rail = $('[data-recent-rail]'); rail.innerHTML = ps.map(function (p) {
          var off = p.compare_at_price > p.price ? Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100) : 0;
          var im = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          return '<article class="as-card"><a class="as-media" href="' + p.url + '" aria-label="' + esc(p.title) + '">' + (im ? '<img src="' + img(im, 600) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="800">' : '') + (off ? '<span class="as-offpill">' + off + '% OFF</span>' : '') + '</a><button type="button" class="as-wish" data-wish="' + esc(p.handle) + '" aria-label="Add to wishlist" aria-pressed="false"><span><svg class="as-icon" viewBox="0 0 24 24" style="width:17px;height:17px"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg></span></button><a class="as-ttl" href="' + p.url + '">' + esc(p.title) + '</a><div class="as-price"><b>' + inr(p.price) + '</b>' + (off ? '<s>' + inr(p.compare_at_price) + '</s>' : '') + '</div>' + (p.available ? '<button type="button" class="as-btn as-btn-outline" data-quick="' + esc(p.handle) + '">Add to cart</button>' : '<a class="as-btn as-btn-outline" href="' + p.url + '">View style</a>') + '</article>';
        }).join('');
        $('[data-recent]').hidden = false; wishSync();
      });
    }
    ui();
  })();

  /* ---------- help centre: on-this-page links ---------- */
  (function () {
    var c = $('[data-help-content]'), toc = $('[data-toc]'); if (!c || !toc) return;
    var heads = $$('h1, h2, h3, h4', c);
    if (heads.length < 2) heads = $$('p > strong:only-child, p > b:only-child', c).map(function (s) { return s.parentElement; }).filter(function (p) { return p.textContent.trim().length < 70; });
    heads = heads.filter(function (hd) { return hd.textContent.trim(); }).slice(0, 8);
    if (heads.length < 2) return;
    heads.forEach(function (hd, i) {
      if (!hd.id) hd.id = 'as-h-' + i;
      hd.style.scrollMarginTop = '110px';
      var a = document.createElement('a'); a.href = '#' + hd.id; a.textContent = hd.textContent.trim().replace(/[:.]$/, '');
      a.addEventListener('click', function (e) { e.preventDefault(); hd.scrollIntoView({ behavior: 'smooth' }); });
      toc.appendChild(a);
    });
    toc.hidden = false;
  })();
  (function () { var a = $('.as-ptabs a.as-on'); if (a) a.parentElement.scrollLeft = a.offsetLeft - 16; })();

  /* ---------- footer ---------- */
  (function () {
    var mq = matchMedia('(max-width: 900px)');
    function sync() { $$('footer.as-site .as-f-main details').forEach(function (d) { d.open = !mq.matches; }); }
    sync(); if (mq.addEventListener) mq.addEventListener('change', sync);
    var t = $('[data-totop]'); if (t) t.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    var j = $('[data-join]');
    if (j) j.addEventListener('submit', function (e) {
      e.preventDefault(); var v = ($('input', j).value || '').replace(/\D/g, '');
      if (v.length !== 10) { toast('Enter a 10-digit mobile number'); return; }
      window.open('https://wa.me/' + (ASN.wa || '917984262177') + '?text=' + encodeURIComponent('Hi Asnowera! Please add me to the Asnowera circle for new drops and offers. My number: +91 ' + v), '_blank', 'noopener');
      toast('Opening WhatsApp to confirm…');
    });
  })();

  /* ---------- reviews: render Judge.me data in the Asnowera design ---------- */
  (function () {
    function starStr(r) { var f = Math.round(r || 0); var s = ''; for (var i = 1; i <= 5; i++) s += i <= f ? '★' : '☆'; return s; }
    function initials(n) { var p = String(n || '').trim().split(/\s+/); return ((p[0] || '')[0] || '') + ((p[1] || '')[0] || ''); }
    function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
    function card(r) {
      return '<article class="as-rv">' +
        '<div class="as-stars" role="img" aria-label="' + r.rating + ' out of 5 stars">' + starStr(r.rating) + '</div>' +
        (r.title ? '<b class="as-rv-title">' + esc(r.title) + '</b>' : '') +
        (r.body ? '<p class="as-rv-text">“' + esc(r.body) + '”</p>' : '<p class="as-rv-text"></p>') +
        (r.pics && r.pics.length ? '<div class="as-rv-pics">' + r.pics.map(function (p, i) { return '<button type="button" data-rvpic="' + r.id + ':' + i + '" aria-label="View customer photo"><img src="' + esc(p) + '" alt="" loading="lazy" width="64" height="64"></button>'; }).join('') + '</div>' : '') +
        '<div class="as-rv-who"><span class="as-av" aria-hidden="true">' + esc(initials(r.name).toUpperCase()) + '</span><span><b>' + esc(r.name || 'Asnowera customer') + '</b><small>' + esc([r.date, r.verified ? 'Verified buyer' : ''].filter(Boolean).join(' · ')) + '</small></span></div>' +
        (r.prodTitle ? '<a class="as-rv-prod" href="' + esc(r.prodUrl || ('/search?type=product&q=' + encodeURIComponent(r.prodTitle))) + '"' + (r.prodUrl ? '' : ' data-rvresolve="' + esc(r.prodTitle) + '"') + '>' + (r.prodImg ? '<img src="' + esc(r.prodImg) + '" alt="" loading="lazy" width="44" height="58">' : '') + '<span>' + esc(r.prodTitle) + '</span></a>' : '') +
        '</article>';
    }
    function bars(rows, total) {
      if (!rows || !rows.length) return '';
      return '<div class="as-rv-bars">' + rows.map(function (x) { var pc = total ? Math.round(x.n * 100 / total) : 0; return '<div><span>' + x.star + '★</span><i><b style="width:' + pc + '%"></b></i><em>' + x.n + '</em></div>'; }).join('') + '</div>';
    }
    function resolveLinks(root) {
      $$('[data-rvresolve]', root).forEach(function (a) {
        var q = a.getAttribute('data-rvresolve'); a.removeAttribute('data-rvresolve');
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=1')
          .then(function (r) { return r.json(); })
          .then(function (d) { var p = d && d.resources && d.resources.results && d.resources.results.products && d.resources.results.products[0]; if (p && p.url) a.href = p.url.split('?')[0]; })
          .catch(function () {});
      });
    }
    function waitFor(test, cb, ms) {
      var t0 = Date.now();
      (function loop() { var v = test(); if (v) return cb(v); if (Date.now() - t0 < (ms || 15000)) setTimeout(loop, 300); })();
    }

    /* home page: featured carousel -> summary card + review cards */
    var home = $('.as-home-reviews');
    if (home) {
      waitFor(function () { return $$('.jdgm-carousel-item', home).length ? $('.jdgm-carousel-wrapper', home) : null; }, function (w) {
        var seen = {};
        var items = $$('.jdgm-carousel-item', w).filter(function (it) { var id = it.getAttribute('data-review-id'); if (!id || seen[id]) return false; seen[id] = 1; return true; });
        var revs = items.map(function (it) {
          var im = $('.jdgm-carousel-item__product-image', it);
          var src = im ? (im.getAttribute('data-src-retina') || im.getAttribute('data-src') || im.getAttribute('src') || '') : '';
          return {
            id: it.getAttribute('data-review-id'),
            rating: $$('.jdgm-carousel-item__review-rating .jdgm--on', it).length + ($('.jdgm-carousel-item__review-rating .jdgm--half', it) ? 0.5 : 0),
            title: txt($('.jdgm-carousel-item__review-title', it)),
            body: txt($('.jdgm-carousel-item__review-body', it)),
            name: txt($('.jdgm-carousel-item__reviewer-name', it)),
            date: '', verified: true,
            prodTitle: im ? im.getAttribute('alt') : '', prodImg: src.replace(/_(70|140)x(70|140)\./, '_200x.')
          };
        }).filter(function (r) { return r.body || r.title; });
        if (!revs.length) return;
        var rt = $('.jdgm-all-reviews-rating', w); var avg = rt ? parseFloat(rt.getAttribute('data-score')) : 0;
        var nEl = $('[data-number-of-reviews]', w); var n = nEl ? parseInt(nEl.getAttribute('data-number-of-reviews'), 10) : 0;
        var box = document.createElement('div');
        box.className = 'as-reviews';
        box.innerHTML = '<div class="as-rv-sum">' +
          (avg ? '<div class="as-rv-score">' + avg.toFixed(1) + '<small>out of 5</small></div><div class="as-stars" role="img" aria-label="Average rating ' + avg.toFixed(1) + ' out of 5">' + starStr(avg) + '</div>' : '') +
          (n ? '<p>Based on ' + n.toLocaleString('en-IN') + ' verified reviews</p>' : '') +
          '<a class="as-btn as-btn-outline" href="/collections/best-selling" style="min-height:44px">Shop best sellers</a></div>' +
          '<div class="as-rv-list as-rv-home">' + revs.slice(0, 9).map(card).join('') + '</div>';
        home.insertBefore(box, home.firstChild);
        home.classList.add('as-rv-ready');
        resolveLinks(box);
      });
    }

    /* product page: review widget -> summary card + review cards (Judge.me keeps the form + paging) */
    var sec = document.getElementById('as-reviews');
    if (sec) {
      waitFor(function () { return $('.jdgm-rev-widg', sec); }, function (w) {
        var box = document.createElement('div'); box.className = 'as-pr-rev';
        var widgWrap = w.closest('.shopify-app-block') || w.closest('.jdgm-widget') || w;
        var seen = {}, acc = [];
        function read() {
          readPage().forEach(function (r) {
            var k = r.el.getAttribute('data-review-id') || [r.name, r.title, (r.body || '').slice(0, 80)].join('|');
            if (seen.hasOwnProperty(k)) { r.id = seen[k]; acc[seen[k]] = r; return; }
            seen[k] = acc.length; r.id = acc.length; acc.push(r);
          });
          return acc;
        }
        function readPage() {
          return $$('.jdgm-rev', w).map(function (el, i) {
            var pics = $$('.jdgm-rev__pic-img', el).map(function (p) { return p.getAttribute('data-src') || p.getAttribute('src') || ''; }).filter(Boolean);
            return {
              id: i, el: el,
              rating: $$('.jdgm-rev__rating .jdgm--on', el).length + ($('.jdgm-rev__rating .jdgm--half', el) ? 0.5 : 0),
              title: txt($('.jdgm-rev__title', el)),
              body: txt($('.jdgm-rev__body', el)),
              name: txt($('.jdgm-rev__author', el)),
              date: txt($('.jdgm-rev__timestamp', el)),
              verified: el.getAttribute('data-verified-buyer') === 'true',
              pics: pics
            };
          });
        }
        function gallery(revs) {
          var all = [];
          revs.forEach(function (r) { (r.pics || []).forEach(function (p, i) { all.push({ src: p, key: r.id + ':' + i }); }); });
          if (!all.length) return '';
          return '<div class="as-rv-gallery"><div class="as-rv-gh"><b>Customer photos</b><span>' + all.length + ' photo' + (all.length === 1 ? '' : 's') + ' from buyers</span></div>' +
            '<div class="as-rv-strip">' + all.map(function (x) { return '<button type="button" data-rvpic="' + x.key + '" aria-label="View customer photo"><img src="' + esc(x.src) + '" alt="" loading="lazy" width="120" height="120"></button>'; }).join('') + '</div></div>';
        }
        function holdScroll() {
          var y = window.scrollY, until = Date.now() + 5000, user = false;
          function stopUser() { user = true; }
          ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, stopUser, { passive: true, once: true }); });
          (function tick() {
            if (user || Date.now() > until) return;
            try { var jq = (window.jdgm && window.jdgm.$) || window.jQuery; if (jq) jq('html, body').stop(true); } catch (err) {}
            if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
            requestAnimationFrame(tick);
          })();
        }
        function moreLink() { return $('.jdgm-paginate__load-more, .jdgm-paginate__next-page', w); }
        function render() {
          var avg = parseFloat(w.getAttribute('data-average-rating')) || 0;
          var n = parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0;
          var rows = $$('.jdgm-histogram__row[data-rating]', w).filter(function (r) { return /^[1-5]$/.test(r.getAttribute('data-rating')); }).map(function (r) { return { star: r.getAttribute('data-rating'), n: parseInt(r.getAttribute('data-frequency'), 10) || 0 }; });
          var revs = read();
          box.innerHTML = '<div class="as-pr-sum">' +
            (n ? '<div class="as-rv-score">' + avg.toFixed(1) + '<small>out of 5</small></div><div class="as-stars" role="img" aria-label="Average rating ' + avg.toFixed(1) + ' out of 5">' + starStr(avg) + '</div><p style="margin:0;color:var(--muted);font-size:13px">Based on ' + n + ' review' + (n === 1 ? '' : 's') + '</p>' + bars(rows, n)
               : '<div class="as-rv-score" style="font-size:22px">No reviews yet</div><p style="margin:0;color:var(--muted);font-size:13px">Bought this style? Tell other shoppers about the fit and fabric.</p>') +
            ($('.jdgm-write-rev-link', w) ? '<button type="button" class="as-btn as-btn-outline" data-rvwrite style="min-height:44px">Write a review</button>' : '') + '</div>' +
            '<div>' + gallery(revs) + '<div class="as-pr-list">' + (revs.length ? revs.map(card).join('') : '<article class="as-rv"><p class="as-rv-text">Be the first to review this style.</p></article>') + '</div>' +
            (moreLink() ? '<div style="text-align:center;margin-top:18px"><button type="button" class="as-btn as-btn-outline" data-rvmore style="min-height:44px">Show more reviews</button></div>' : '') + '</div>';
        }
        render();
        widgWrap.parentNode.insertBefore(box, widgWrap);
        w.classList.add('as-jdgm-src');
        box.addEventListener('click', function (e) {
          var b = e.target.closest('[data-rvwrite],[data-rvmore],[data-rvpic]'); if (!b) return;
          if (b.hasAttribute('data-rvwrite')) {
            var l = $('.jdgm-write-rev-link', w); if (l) l.click();
            w.classList.add('as-jdgm-form-open');
            setTimeout(function () { var f = $('.jdgm-form-wrapper', w); if (f) f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }, 250);
          } else if (b.hasAttribute('data-rvmore')) {
            var m = moreLink(); if (m) { holdScroll(); m.click(); b.disabled = true; b.textContent = 'Loading…'; }
          } else {
            var parts = b.getAttribute('data-rvpic').split(':'); var r = read()[+parts[0]];
            var links = r ? $$('.jdgm-rev__pic-link', r.el) : []; var a = links[+parts[1]];
            if (a && document.contains(a)) a.click();
            else if (r && r.pics && r.pics[+parts[1]]) window.open(r.pics[+parts[1]], '_blank', 'noopener');
          }
        });
        var body = $('.jdgm-rev-widg__body', w) || w; var tm;
        new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(render, 200); }).observe(body, { childList: true, subtree: true });
      });
    }
  })();

  /* ---------- size guide popup (no page change) ---------- */
  (function () {
    var dlg = document.getElementById('as-size-guide'); if (!dlg || typeof dlg.showModal !== 'function') return;
    var app = dlg.querySelector('[data-sg-app]'), go = dlg.querySelector('[data-sg-go]');
    var S = ['S', 'M', 'L', 'XL', 'XXL'];
    var D = {
      top: { body: [['Bust', [36, 38, 40, 42, 44]], ['Waist', [34, 36, 38, 40, 42]], ['Hips', [38, 40, 42, 44, 46]]],
        g: [['Shirt length', [27, 28, 29, 30, 31]], ['Shirt sleeve', [21, 21, 21, 21, 21]], ['Tunic length', [31, 31, 31, 31, 31]], ['Tunic sleeve', [17, 17, 17, 17, 17]]] },
      bottom: { body: [['Waist', [26, 28, 30, 32, 34]], ['Hips', [38, 40, 42, 44, 46]]],
        g: [['Ankle round', [9, 9, 9, 9.5, 9.5]], ['Length', [38, 38, 38, 38, 38]]] }
    };
    var st = { p: 'top', u: 'in', s: 'M' }, ctx = null;
    var FIG = '<svg viewBox="0 0 120 220" fill="none" aria-hidden="true"><path d="M60 14c7 0 11 5 11 12s-4 13-11 13-11-6-11-13 4-12 11-12z" stroke="#A0526F" stroke-width="2"/><path d="M54 39v7c-10 2-20 6-24 12l-8 46c-1 5 6 6 7 1l8-38 2 30c1 6-4 10-5 18-2 12-2 22 6 26l3 70h9l4-66 4 66h9l3-70c8-4 8-14 6-26-1-8-6-12-5-18l2-30 8 38c1 5 8 4 7-1l-8-46c-4-6-14-10-24-12v-7" stroke="#A0526F" stroke-width="2" stroke-linejoin="round"/><g stroke="#6B1F3F" stroke-width="2" stroke-dasharray="3 3"><ellipse cx="60" cy="70" rx="23" ry="5"/><ellipse cx="60" cy="96" rx="17" ry="4"/><ellipse cx="60" cy="122" rx="23" ry="5"/></g><g font-family="Poppins,sans-serif" font-size="10" font-weight="700" fill="#fff" text-anchor="middle"><circle cx="96" cy="70" r="9" fill="#6B1F3F"/><text x="96" y="74">1</text><circle cx="90" cy="96" r="9" fill="#6B1F3F"/><text x="90" y="100">2</text><circle cx="96" cy="122" r="9" fill="#6B1F3F"/><text x="96" y="126">3</text></g></svg>';
    function cv(v) { return st.u === 'cm' ? Math.round(v * 2.54) : v; }
    function sizeBtns() {
      if (!ctx) return [];
      return Array.prototype.slice.call(ctx.querySelectorAll('.as-sz')).filter(function (b) { return S.indexOf(String(b.getAttribute('data-val') || b.getAttribute('data-v') || '').trim().toUpperCase()) > -1; });
    }
    function btnFor(s) { return sizeBtns().filter(function (b) { return String(b.getAttribute('data-val') || b.getAttribute('data-v')).trim().toUpperCase() === s; })[0]; }
    function draw() {
      var d = D[st.p], i = S.indexOf(st.s), open = app.querySelector('details[open]');
      function tr(r) { return '<tr><th scope="row">' + r[0] + '</th>' + r[1].map(function (v, k) { return '<td' + (k === i ? ' class="on"' : '') + '>' + cv(v) + '</td>'; }).join('') + '</tr>'; }
      app.innerHTML =
        '<div class="sg2-seg" role="tablist"><button type="button" role="tab" data-sg-p="top" aria-selected="' + (st.p === 'top') + '"' + (st.p === 'top' ? ' class="on"' : '') + '>Top</button><button type="button" role="tab" data-sg-p="bottom" aria-selected="' + (st.p === 'bottom') + '"' + (st.p === 'bottom' ? ' class="on"' : '') + '>Bottom</button></div>' +
        '<div class="sg2-row"><b>Tap your size</b><div class="sg2-mini"><button type="button" data-sg-u="in"' + (st.u === 'in' ? ' class="on"' : '') + '>in</button><button type="button" data-sg-u="cm"' + (st.u === 'cm' ? ' class="on"' : '') + '>cm</button></div></div>' +
        '<div class="sg2-tw"><table class="sg2-t sg2-l"><thead><tr class="sg2-gh"><th></th>' + [['Body measurements', d.body], [st.p === 'top' ? 'Garment length' : 'Garment', d.g]].map(function (g, gi) { return '<th colspan="' + g[1].length + '"' + (gi ? ' class="sg2-gs"' : '') + '>' + g[0] + '</th>'; }).join('') + '</tr><tr><th scope="col">Size</th>' + d.body.concat(d.g).map(function (r, ci) { return '<th scope="col"' + (ci === d.body.length ? ' class="sg2-gs"' : '') + '>' + r[0] + '<small>' + st.u + '</small></th>'; }).join('') + '</tr></thead><tbody>' +
        S.map(function (s, k) { return '<tr' + (k === i ? ' class="on"' : '') + '><th scope="row"><button type="button" data-sg-s="' + s + '" aria-pressed="' + (k === i) + '">' + s + '</button></th>' + d.body.concat(d.g).map(function (r, ci) { return '<td' + (ci === d.body.length ? ' class="sg2-gs"' : '') + '>' + cv(r[1][k]) + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody></table></div>' +
        '<div class="sg2-tip"><span aria-hidden="true">💡</span><span><b>Between sizes?</b> Go by your largest measurement and pick the larger size.</span></div>' +
        '<details class="sg2-acc"' + (open ? ' open' : '') + '><summary>How to measure</summary><div class="sg2-how">' + FIG + '<ol><li><span>1</span><div><b>Bust:</b> around the fullest part of your chest.</div></li><li><span>2</span><div><b>Waist:</b> around your natural (narrowest) waist.</div></li><li><span>3</span><div><b>Hips:</b> around the fullest part of your hips.</div></li></ol></div></details>' +
        '<p class="sg2-mail">Need help? Email <a href="mailto:info@asnowera.com">info@asnowera.com</a> or tap WhatsApp below.</p>';
      var b = btnFor(st.s);
      if (b && b.disabled) { go.textContent = 'Size ' + st.s + ' is sold out'; go.disabled = true; }
      else { go.textContent = ctx && b ? 'Select size ' + st.s : 'Done'; go.disabled = false; }
    }
    dlg.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sg-p],[data-sg-u],[data-sg-s]'); if (!t) { var row = e.target.closest('.sg2-t tbody tr'); t = row && row.querySelector('[data-sg-s]'); } if (!t) return;
      if (t.hasAttribute('data-sg-p')) st.p = t.getAttribute('data-sg-p');
      if (t.hasAttribute('data-sg-u')) st.u = t.getAttribute('data-sg-u');
      if (t.hasAttribute('data-sg-s')) st.s = t.getAttribute('data-sg-s');
      draw();
    });
    go.addEventListener('click', function () {
      var b = btnFor(st.s);
      if (b && !b.disabled) b.click();
      dlg.close();
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-size-guide]');
      if (a) {
        e.preventDefault();
        ctx = a.closest('#as-quick') || a.closest('[data-pdp]') || document.querySelector('[data-pdp]');
        var cur = sizeBtns().filter(function (b) { return b.classList.contains('as-on'); })[0];
        if (cur) st.s = String(cur.getAttribute('data-val') || cur.getAttribute('data-v')).trim().toUpperCase();
        draw();
        if (!dlg.open) dlg.showModal();
        return;
      }
      if (dlg.open && (e.target.closest('[data-sg-close]') || e.target === dlg)) dlg.close();
    });
  })();

  /* ---------- collection colour filter (from product titles + Color option, works with all other filters) ---------- */
  (function () {
    var boxes = $$('[data-colorf]'); if (!boxes.length) return;
    var handle = boxes[0].getAttribute('data-handle'); if (!handle) return;
    var FAM = [
      { k: 'red', n: 'Red', hex: '#C9303A', w: ['red', 'scarlet', 'crimson', 'cherry'] },
      { k: 'maroon', n: 'Maroon', hex: '#6E1F35', w: ['maroon', 'wine', 'burgundy'] },
      { k: 'pink', n: 'Pink', hex: '#EA8DB1', w: ['pink', 'rose', 'fuchsia', 'magenta', 'blush'] },
      { k: 'peach', n: 'Peach', hex: '#F5B49A', w: ['peach', 'coral'] },
      { k: 'orange', n: 'Orange', hex: '#E9782F', w: ['orange', 'rust'] },
      { k: 'yellow', n: 'Yellow', hex: '#EBC43C', w: ['yellow', 'mustard', 'lemon', 'gold', 'golden'] },
      { k: 'green', n: 'Green', hex: '#3F8F5B', w: ['green', 'emerald', 'sage', 'mint', 'olive', 'pista', 'pistachio'] },
      { k: 'teal', n: 'Teal', hex: '#1E9A9A', w: ['teal', 'turquoise', 'aqua', 'cyan'] },
      { k: 'blue', n: 'Blue', hex: '#2F5EA8', w: ['blue', 'navy', 'sky', 'denim', 'azure', 'indigo', 'cobalt'] },
      { k: 'purple', n: 'Purple', hex: '#8B5CB8', w: ['purple', 'lavender', 'lilac', 'violet', 'mauve'] },
      { k: 'white', n: 'White', hex: '#FFFFFF', w: ['white', 'ivory'] },
      { k: 'beige', n: 'Beige', hex: '#E7D6BC', w: ['beige', 'cream', 'nude', 'khaki', 'sand', 'champagne', 'offwhite'] },
      { k: 'brown', n: 'Brown', hex: '#8A5A3B', w: ['brown', 'chocolate', 'coffee', 'tan', 'camel'] },
      { k: 'grey', n: 'Grey', hex: '#9C9A9B', w: ['grey', 'gray', 'silver', 'charcoal'] },
      { k: 'black', n: 'Black', hex: '#2A2427', w: ['black'] },
      { k: 'multi', n: 'Multicolour', hex: 'conic-gradient(#C9303A,#EBC43C,#3F8F5B,#2F5EA8,#8B5CB8,#C9303A)', w: ['multicolor', 'multicolour', 'multi'] }
    ];
    function fams(text) {
      var t = ' ' + String(text || '').toLowerCase().replace(/off[\s-]white/g, 'offwhite').replace(/[^a-z]+/g, ' ') + ' ';
      return FAM.filter(function (f) { return f.w.some(function (w) { return t.indexOf(' ' + w + ' ') > -1; }); }).map(function (f) { return f.k; });
    }
    var url = new URL(location.href);
    var active = (url.searchParams.get('color') || '').split(',').filter(Boolean);
    var grid = $('[data-grid]'), more = $('[data-more]');
    var orig = grid ? grid.innerHTML : '';
    var cntEls = $$('.as-toolbar b, .as-mcount'), origCnt = cntEls.map(function (e) { return e.innerHTML; });
    var all = null;
    function loadAll() {
      if (all) return all;
      var lm = $('[data-load-more]'); var total = lm ? Number(lm.getAttribute('data-total')) : $$('.as-card', grid).length;
      var pages = Math.max(1, Math.ceil(total / 24));
      var base = new URL(location.href); base.searchParams.delete('color'); base.searchParams.delete('page');
      var reqs = []; for (var p = 1; p <= pages; p++) { var u = new URL(base); u.searchParams.set('page', p); reqs.push(fetch(u.toString()).then(function (r) { return r.text(); })); }
      all = Promise.all(reqs).then(function (htmls) {
        var seen = {}, cards = [];
        htmls.forEach(function (h) { var d = new DOMParser().parseFromString(h, 'text/html'); $$('[data-grid] .as-card', d).forEach(function (c) { var k = c.getAttribute('data-handle'); if (!seen[k]) { seen[k] = 1; cards.push(c); } }); });
        return cards;
      });
      return all;
    }
    function setCount(n) { cntEls.forEach(function (e) { e.innerHTML = e.classList.contains('as-mcount') ? n + ' styles' : String(n); }); }
    function chips() {
      $$('[data-color-chip]').forEach(function (c) { c.remove(); });
      if (!active.length || !grid) return;
      var wrap = $('.as-active-f');
      if (!wrap) { wrap = document.createElement('div'); wrap.className = 'as-active-f'; wrap.setAttribute('data-color-chip', ''); grid.parentNode.insertBefore(wrap, grid); }
      var html = active.map(function (k) { var f = FAM.filter(function (x) { return x.k === k; })[0]; return f ? '<button type="button" class="as-af" data-color="' + k + '" data-color-chip aria-label="Remove colour ' + f.n + '">' + f.n + ' <svg class="as-icon" viewBox="0 0 24 24" style="width:13px;height:13px;stroke-width:2.2"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' : ''; }).join('');
      wrap.insertAdjacentHTML('afterbegin', html);
    }
    function sync() {
      $$('[data-colorf] [data-color]').forEach(function (b) { var on = active.indexOf(b.getAttribute('data-color')) > -1; b.classList.toggle('as-on', on); b.setAttribute('aria-pressed', String(on)); });
      var u = new URL(location.href); if (active.length) u.searchParams.set('color', active.join(',')); else u.searchParams.delete('color');
      history.replaceState(null, '', u.toString());
      chips();
    }
    function apply() {
      if (!grid) return;
      if (!active.length) { grid.innerHTML = orig; cntEls.forEach(function (e, i) { e.innerHTML = origCnt[i]; }); if (more) more.hidden = false; wishSync(); return; }
      grid.style.opacity = '.5';
      loadAll().then(function (cards) {
        var m = cards.filter(function (c) { var f = fams(c.getAttribute('data-ctext') || c.textContent); return active.some(function (k) { return f.indexOf(k) > -1; }); });
        grid.innerHTML = m.length ? m.map(function (c) { return c.outerHTML; }).join('') : '<div class="as-empty" style="grid-column:1/-1"><b style="color:var(--ink);display:block;font-size:16px;margin-bottom:6px">No styles in this colour with the current filters</b><button type="button" class="as-btn as-btn-outline" data-color-clear style="margin-top:10px">Clear colour</button></div>';
        setCount(m.length); if (more) more.hidden = true; grid.style.opacity = ''; wishSync();
        var tb = $('.as-toolbar') || grid; if (tb.getBoundingClientRect().top < 0 || tb.getBoundingClientRect().top > innerHeight) window.scrollTo({ top: tb.getBoundingClientRect().top + scrollY - 100, behavior: reduce ? 'auto' : 'smooth' });
      }).catch(function () { grid.style.opacity = ''; });
    }
    document.addEventListener('click', function (e) {
      var clr = e.target.closest('[data-color-clear]'); if (clr) { active = []; sync(); apply(); return; }
      var b = e.target.closest('[data-color]'); if (!b) return;
      e.preventDefault();
      var k = b.getAttribute('data-color'), i = active.indexOf(k);
      if (i > -1) active.splice(i, 1); else active.push(k);
      sync(); apply();
    });
    fetch('/collections/' + handle + '/products.json?limit=250').then(function (r) { return r.json(); }).then(function (d) {
      var counts = {};
      (d.products || []).forEach(function (p) {
        var opt = (p.options || []).filter(function (o) { return /colou?r/i.test(o.name); }).map(function (o) { return (o.values || []).join(' '); }).join(' ');
        fams(p.title + ' ' + opt).forEach(function (k) { counts[k] = (counts[k] || 0) + 1; });
      });
      var list = FAM.filter(function (f) { return counts[f.k]; });
      if (!list.length) return;
      boxes.forEach(function (b) {
        b.innerHTML = list.map(function (f) { var on = active.indexOf(f.k) > -1; return '<button type="button" class="as-fval' + (on ? ' as-on' : '') + '" data-color="' + f.k + '" aria-pressed="' + on + '"><span class="as-swatch" style="background:' + f.hex + '"></span>' + f.n + '<small>' + counts[f.k] + '</small></button>'; }).join('');
        var w = b.closest('[data-colorf-wrap]'); if (w) w.hidden = false;
      });
      if (active.length) { chips(); apply(); }
    }).catch(function () {});
  })();

  // keep the count fresh when coming back to a cached page
  window.addEventListener('pageshow', function (e) { if (e.persisted) getCart(); });
})();

/* sticky bars sit right under the real header height (fixes gap on phones that report a status-bar safe area) */
(function () {
  function setTop() {
    var h = document.querySelector('.as-header-section') || document.querySelector('header.as-site');
    if (!h) return;
    var r = h.getBoundingClientRect();
    if (r.height > 0) document.documentElement.style.setProperty('--as-sticky-top', Math.round(r.height) + 'px');
  }
  setTop();
  document.addEventListener('DOMContentLoaded', setTop);
  window.addEventListener('load', setTop);
  window.addEventListener('resize', setTop);
  window.addEventListener('orientationchange', setTop);
})();


/* product photo viewer: tap a product photo -> full-screen, uncropped, swipe between photos, double-tap to zoom */
(function () {
  var SEL = '.as-gal-m .as-track img, .as-gallery img';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lb, track, countEl, list = [], cur = 0, srcImgs = [], openedWithHistory = false, closing = false;

  function big(img) {
    var ss = img.getAttribute('srcset');
    if (ss) {
      var best = null, bw = 0;
      ss.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/), w = parseInt(bits[1], 10) || 0;
        if (bits[0] && w >= bw) { bw = w; best = bits[0]; }
      });
      if (best) return best.replace(/([?&])width=\d+/, '$1width=1800');
    }
    return (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=1800');
  }

  function build() {
    lb = document.createElement('div');
    lb.className = 'as-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product photos');
    lb.innerHTML =
      '<div class="as-lb-bg"></div>' +
      '<div class="as-lb-track" tabindex="-1"></div>' +
      '<div class="as-lb-top"><span class="as-lb-count"></span>' +
      '<button type="button" class="as-lb-btn as-lb-close" aria-label="Close photos"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<button type="button" class="as-lb-btn as-lb-nav as-lb-prev" aria-label="Previous photo"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' +
      '<button type="button" class="as-lb-btn as-lb-nav as-lb-next" aria-label="Next photo"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>' +
      '<p class="as-lb-hint">Double-tap to zoom</p>';
    document.body.appendChild(lb);
    track = lb.querySelector('.as-lb-track');
    countEl = lb.querySelector('.as-lb-count');
    lb.querySelector('.as-lb-close').addEventListener('click', function () { close(); });
    lb.querySelector('.as-lb-prev').addEventListener('click', function () { go(cur - 1); });
    lb.querySelector('.as-lb-next').addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== cur && i >= 0 && i < list.length) { unzoomAll(); cur = i; label(); }
    }, { passive: true });
    track.addEventListener('click', function (e) {
      // tap on empty space around the photo closes
      if (e.target.classList.contains('as-lb-slide')) close();
    });
    var lastTap = 0;
    track.addEventListener('dblclick', function (e) { var s = e.target.closest('.as-lb-slide'); if (s) { e.preventDefault(); toggleZoom(s, e); } });
    track.addEventListener('touchend', function (e) {
      var now = Date.now(), s = e.target.closest('.as-lb-slide');
      if (s && now - lastTap < 300 && e.changedTouches.length === 1) { e.preventDefault(); toggleZoom(s, e.changedTouches[0]); lastTap = 0; }
      else lastTap = now;
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('as-on')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(cur + 1);
      else if (e.key === 'ArrowLeft') go(cur - 1);
    });
    window.addEventListener('popstate', function () { if (lb.classList.contains('as-on')) { openedWithHistory = false; close(); } });
  }

  function label() {
    countEl.textContent = (cur + 1) + ' / ' + list.length;
    lb.querySelector('.as-lb-prev').hidden = cur <= 0;
    lb.querySelector('.as-lb-next').hidden = cur >= list.length - 1;
  }

  function go(i) {
    if (i < 0 || i >= list.length) return;
    unzoomAll();
    track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
  }

  function unzoomAll() {
    Array.prototype.forEach.call(track.querySelectorAll('.as-lb-slide.as-zoom'), function (s) { s.classList.remove('as-zoom'); s.scrollTop = 0; s.scrollLeft = 0; });
    track.classList.remove('as-lb-zoomed');
  }

  function toggleZoom(slide, pt) {
    if (slide.classList.contains('as-zoom')) { unzoomAll(); return; }
    var img = slide.querySelector('img'), r = img.getBoundingClientRect();
    var fx = r.width ? (pt.clientX - r.left) / r.width : 0.5, fy = r.height ? (pt.clientY - r.top) / r.height : 0.5;
    slide.classList.add('as-zoom');
    track.classList.add('as-lb-zoomed');
    requestAnimationFrame(function () {
      slide.scrollLeft = Math.max(0, img.offsetWidth * fx - slide.clientWidth / 2);
      slide.scrollTop = Math.max(0, img.offsetHeight * fy - slide.clientHeight / 2);
    });
    var h = lb.querySelector('.as-lb-hint'); if (h) h.remove();
  }

  function fitRect(nw, nh) {
    var pad = window.innerWidth < 700 ? 0 : 48, top = 56, bottom = window.innerWidth < 700 ? 40 : 48;
    var aw = window.innerWidth - pad * 2, ah = window.innerHeight - top - bottom;
    var s = Math.min(aw / nw, ah / nh);
    var w = nw * s, h = nh * s;
    return { left: (window.innerWidth - w) / 2, top: top + (ah - h) / 2, width: w, height: h };
  }

  function flyFrom(img, toRect, done) {
    var from = img.getBoundingClientRect();
    if (reduce || !from.width || !ghostOK(from)) { done(); return; }
    var g = document.createElement('img');
    g.className = 'as-lb-ghost';
    g.src = img.currentSrc || img.src;
    g.style.cssText = 'left:' + toRect.left + 'px;top:' + toRect.top + 'px;width:' + toRect.width + 'px;height:' + toRect.height + 'px';
    lb.appendChild(g);
    var anim = g.animate([
      { left: from.left + 'px', top: from.top + 'px', width: from.width + 'px', height: from.height + 'px', borderRadius: '10px' },
      { left: toRect.left + 'px', top: toRect.top + 'px', width: toRect.width + 'px', height: toRect.height + 'px', borderRadius: '0px' }
    ], { duration: 380, easing: 'cubic-bezier(.2,.8,.2,1)' });
    anim.onfinish = function () { done(); requestAnimationFrame(function () { g.remove(); }); };
  }
  function ghostOK(r) { return r.bottom > 0 && r.top < window.innerHeight; }

  function open(clicked) {
    if (!lb) build();
    var box = clicked.closest('.as-track, .as-gallery');
    srcImgs = Array.prototype.slice.call(box.querySelectorAll('img'));
    list = srcImgs.map(big);
    cur = Math.max(0, srcImgs.indexOf(clicked));
    track.innerHTML = list.map(function (u, i) {
      return '<div class="as-lb-slide"><img src="' + u + '" alt="' + ((srcImgs[i].getAttribute('alt') || 'Product photo') + '').replace(/"/g, '&quot;') + '" draggable="false"' + (Math.abs(i - cur) > 1 ? ' loading="lazy"' : '') + '></div>';
    }).join('');
    document.documentElement.classList.add('as-lb-lock');
    lb.classList.add('as-on');
    lb.classList.remove('as-out');
    track.style.visibility = 'hidden';
    track.scrollLeft = cur * track.clientWidth;
    label();
    try { history.pushState({ asLb: 1 }, ''); openedWithHistory = true; } catch (e) { openedWithHistory = false; }
    var nw = clicked.naturalWidth || 3, nh = clicked.naturalHeight || 4;
    flyFrom(clicked, fitRect(nw, nh), function () { track.style.visibility = ''; });
    lb.querySelector('.as-lb-close').focus({ preventScroll: true });
  }

  function syncGallery() {
    var t = document.querySelector('.as-gal-m [data-thumb="' + cur + '"]');
    if (t) t.click();
    else {
      var tr = document.querySelector('.as-gal-m .as-track');
      if (tr) tr.scrollTo({ left: cur * tr.clientWidth });
    }
  }

  function close() {
    if (!lb || !lb.classList.contains('as-on') || closing) return;
    closing = true;
    unzoomAll();
    syncGallery();
    if (openedWithHistory) { openedWithHistory = false; try { history.back(); } catch (e) {} }
    var target = srcImgs[cur];
    var slideImg = track.children[cur] && track.children[cur].querySelector('img');
    function finish() {
      lb.classList.remove('as-on', 'as-out');
      document.documentElement.classList.remove('as-lb-lock');
      track.innerHTML = '';
      closing = false;
    }
    lb.classList.add('as-out');
    if (reduce || !target || !slideImg) { setTimeout(finish, reduce ? 0 : 220); return; }
    setTimeout(function () {
      var to = target.getBoundingClientRect(), from = slideImg.getBoundingClientRect();
      if (!to.width || !from.width || !ghostOK(to)) { finish(); return; }
      var g = document.createElement('img');
      g.className = 'as-lb-ghost';
      g.src = slideImg.currentSrc || slideImg.src;
      g.style.cssText = 'left:' + from.left + 'px;top:' + from.top + 'px;width:' + from.width + 'px;height:' + from.height + 'px';
      lb.appendChild(g);
      track.style.visibility = 'hidden';
      var a = g.animate([
        { left: from.left + 'px', top: from.top + 'px', width: from.width + 'px', height: from.height + 'px', borderRadius: '0px' },
        { left: to.left + 'px', top: to.top + 'px', width: to.width + 'px', height: to.height + 'px', borderRadius: '10px' }
      ], { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
      a.onfinish = function () { g.remove(); track.style.visibility = ''; finish(); };
    }, 30);
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest(SEL);
    if (!img) return;
    e.preventDefault();
    open(img);
  });
})();

/* whatmore rows: hide a row only if it has been on screen for a while and Whatmore rendered no videos (its widget loads lazily) */
(function () {
  function has(s) { return !!s.querySelector('video, iframe, img'); }
  function watch(s) {
    var timer = null;
    if (window.MutationObserver) new MutationObserver(function () { if (has(s)) { s.classList.remove('as-wm-empty'); clearTimeout(timer); } }).observe(s, { childList: true, subtree: true });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && !timer && !has(s)) timer = setTimeout(function () { if (!has(s)) s.classList.add('as-wm-empty'); }, 7000);
      });
    }, { rootMargin: '200px 0px' });
    io.observe(s);
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-wm]'), watch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* size guide page: Top/Bottom tabs, in/cm, size highlight (landscape rows) */
(function () {
  var root = document.querySelector('[data-asz]'); if (!root) return;
  var ctrl = root.querySelector('[data-asz-ctrl]'); if (ctrl) ctrl.hidden = false;
  root.classList.add('asz-js');
  var st = { p: 'top', u: 'in', s: 1 };
  function apply() {
    root.querySelectorAll('[data-asz-pane]').forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-asz-pane') === st.p); });
    root.querySelectorAll('[data-asz-p]').forEach(function (b) { var on = b.getAttribute('data-asz-p') === st.p; b.classList.toggle('on', on); b.setAttribute('aria-selected', String(on)); });
    root.querySelectorAll('[data-asz-u]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-asz-u') === st.u); });
    root.querySelectorAll('[data-asz-ul]').forEach(function (l) { l.textContent = st.u; });
    root.querySelectorAll('td[data-in]').forEach(function (td) { var v = parseFloat(td.getAttribute('data-in')); td.textContent = st.u === 'cm' ? Math.round(v * 2.54) : td.getAttribute('data-in'); });
    root.querySelectorAll('.asz-t tbody tr').forEach(function (tr, i, all) { var b = tr.querySelector('[data-asz-s]'); var on = b && +b.getAttribute('data-asz-s') === st.s; tr.classList.toggle('on', !!on); if (b) b.setAttribute('aria-pressed', String(!!on)); });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-asz-p],[data-asz-u],[data-asz-s],.asz-t tbody tr'); if (!b) return;
    if (b.hasAttribute('data-asz-p')) st.p = b.getAttribute('data-asz-p');
    else if (b.hasAttribute('data-asz-u')) st.u = b.getAttribute('data-asz-u');
    else if (b.hasAttribute('data-asz-s')) st.s = +b.getAttribute('data-asz-s');
    else { var s = b.querySelector('[data-asz-s]'); if (s) st.s = +s.getAttribute('data-asz-s'); }
    apply();
  });
  apply();
})();
